'helper'.trashAll('Configuration')
'helper'.trashAll('POReceipt')
'helper'.trashAll('PO')
'helper'.trashAll('UOM')
'helper'.trashAll('SO')
'helper'.trashAll('Inventory')
'helper'.trashAll('Facet')
'helper'.trashAll('Template')
'helper'.trashAll('Supplier')
'helper'.clearWCOrders()
'helper'.clearWCStockLevels()
'helper'.simulateBrowserRefresh()
'stocktend_settings'.click()
  'Default Stocking Unit of Measure'.shouldEqual('')
  'Show Unit of Measure on PO Lines'.shouldEqual('No')
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00001')
    'Add Line'.click()
      'Product'.enter('Hoodie (H01)')
      'Purchasing Unit of Measure'.shouldntExist()
      'OK'.click()
    'Lines.0.UOM'.shouldntExist()
    'Download PDF'.click()
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00003')
    'Add Line'.click()
      'Product'.enter('Hoodie (H01)')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_receivePurchases'.click()
  'mainTable./PO00003/.Enter Receipt'.click()
    'Lines.0.Edit'.click()
      'Purchasing Unit'.shouldntExist()
      'Received Stocking Units'.shouldntExist()
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_settings'.click()
  'Units of Measure'.click()
    'mainTable'.shouldHaveCount(0)
    'Add'.click()
      'Unit of Measure Name'.enter('Each')
      'Description'.enter('Individual saleable items')
      'OK'.click()
    'Add'.click()
      'Unit of Measure Name'.enter('CTN')
      'Description'.enter('Carton')
      'OK'.click()
    'mainTable'.shouldHaveCount(2)
    'Back'.click()
  'Back'.click()
'stocktend_settings'.click()
  'Default Stocking Unit of Measure'.enter('Each')
  'Show Unit of Measure on PO Lines'.enter('Yes')
  'OK'.click()
'stocktend_purchaseOrders'.click()
  'mainTable./PO00001/.Edit'.click()
    'Lines.0.UOM'.shouldEqual('Each')
    'Download PDF'.click()
    'OK'.click()
  'mainTable./PO00001/.Trash'.click()
  'mainTable./PO00001/.Really Trash?'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'mainTable./Hoodie (H01)/.Edit Product'.click()
    'Use Different Unit of Measure for Purchasing'.shouldEqual('No')
    'Purchasing Unit of Measure'.shouldntExist()
    'Stocking Quantity per Purchasing Unit'.shouldntExist()
    'Use Different Unit of Measure for Purchasing'.enter('Yes')
    'Purchasing Unit of Measure'.shouldEqual('Each')
    'Stocking Quantity per Purchasing Unit'.shouldntExist()
    'Purchasing Unit of Measure'.enter('CTN')
    'Stocking Quantity per Purchasing Unit'.shouldEqual('1')
    'Stocking Quantity per Purchasing Unit'.enter('6')
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00002')
    'Add Line'.click()
      'Purchasing Unit of Measure'.shouldntExist()
      'Purchasing Unit Quantity'.shouldntExist()
      'Product'.enter('Hoodie (H01)')
      'Purchasing Unit of Measure'.shouldEqual('CTN')
      'Purchasing Unit Quantity'.shouldExist()
      'Purchasing Unit Quantity'.shouldEqual('1')
      'Quantity'.shouldEqual('6')
      'Quantity'.shouldBeReadOnly()
      'Purchasing Unit Quantity'.enter('9')
      'Quantity'.shouldEqual('54')
      'OK'.click()
    'Lines.0.Purch Unit Qty'.shouldEqual('9')
    'Lines.0.UOM'.shouldEqual('CTN')
    'Lines.0.Quantity'.shouldEqual('54')
    'Lines.0.Purch Unit Qty'.enter('10')
    'Lines.0.Quantity'.shouldEqual('60')
    'Lines.0.Quantity'.shouldBeReadOnly()
    'Lines.0.Edit'.click()
      'Purchasing Unit of Measure'.shouldEqual('CTN')
      'Product'.enter('Big Bag (BB01)')
      'Purchasing Unit of Measure'.shouldEqual('Each')
      'Product'.enter('Cap (C01)')
      'Purchasing Unit of Measure'.shouldEqual('Each')
      'Product'.enter('Hoodie (H01)')
      'Purchasing Unit of Measure'.shouldEqual('CTN')
      'OK'.click()
    'Lines.0.Purch Unit Qty'.enter('10')
    'Download PDF'.click()
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Purchase Orders/.Run'.click()
    'mainTable./PO00002/.Ordered Quantity'.shouldEqual('60')
    'Back'.click()
  'Back'.click()
'stocktend_receivePurchases'.click()
  'mainTable./PO00002/.Enter Receipt'.click()
    'Lines.0.Edit'.click()
      'Purchasing Unit'.shouldEqual('CTN')
      'Ordered Quantity'.shouldEqual('10')
      'Received'.shouldEqual('10')
      'Previously Received'.shouldEqual('0')
      'Cancelled Quantity'.shouldEqual('0')
      'Outstanding Quantity'.shouldEqual('0')
      'Received Stocking Units'.shouldEqual('60')
      'Received Stocking Units'.shouldBeReadOnly()
      'Received'.enter('4')
      'Received Stocking Units'.shouldEqual('24')
      'Outstanding Quantity'.shouldEqual('6')
      'Cancelled Quantity'.enter('1')
      'Outstanding Quantity'.shouldEqual('5')
      'OK'.click()
    'OK'.click()
'stocktend_inventory'.click()
  'mainTable./Hoodie (H01)/.On Purchase Orders'.shouldEqual('30')
  'Back'.click()
'stocktend_receivePurchases'.click()
  'mainTable./PO00002/.Enter Receipt'.click()
    'Lines.0.Edit'.click()
      'Ordered Quantity'.shouldEqual('10')
      'Previously Received'.shouldEqual('4')
      'Received'.shouldEqual('5')
      'Received Stocking Units'.shouldEqual('30')
      'OK'.click()
    'Lines.0.UOM'.shouldEqual('CTN')
    'Lines.0.Ordered'.shouldEqual('10')
    'Lines.0.Received'.shouldEqual('5')
    'Lines.0.Previously Received'.shouldEqual('4')
    'Lines.0.Cancelled'.shouldEqual('0')
    'Lines.0.Received Stock Units'.shouldEqual('30')
    'Lines.0.Received'.enter('4')
    'Lines.0.Received Stock Units'.shouldEqual('24')
    'Lines.0.Cancelled'.enter('1')
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable./PO00002/.Status'.shouldEqual('Received')
  'Back'.click()
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter('Bombast Corporation')
    'OK'.click()
'stocktend_inventory'.click()
  'mainTable./Hoodie (H01)/.Quantity On Hand'.shouldEqual('49')
  'mainTable./Hoodie (H01)/.Edit Product'.click()
    'Low Stock Threshold'.enter(50)
    'Maximum Quantity to Replenish To'.enter(87)
    'Add Supplier'.click()
      'Supplier'.enter('Bombast Corporation')
      'Barcode'.enter('RFT918273645')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('AutoTest')
    'Supplier'.enter('Bombast Corporation')
    'Auto Lines - Min-Max'.click()
    'lines'.shouldHaveCount(1)
    'lines.0.UOM'.shouldEqual('CTN')
    'lines.0.Purch Unit Qty'.shouldEqual('7')
    'lines.0.Quantity'.shouldEqual('42')
    'OK'.click()
  'Back'.click()
'Receive Purchases'.click()
  'mainTable./AutoTest/.Enter Receipt'.click()
    'Lines./Hoodie (H01)/.Received'.shouldEqual('7')
    'Scan Status'.shouldntExist()
    'Scan Products In'.click()
    'Lines./Hoodie (H01)/.Received'.shouldEqual('0')
    'Scan Status'.shouldEqual('Ready for you to start scanning')
    'helper'.simulateScannerRead('RFT918273645')
      'Edit Receipt Line'.shouldBeCurrentPage()
      'Received'.shouldEqual('1')
      'Received Stocking Units'.shouldEqual('6')
      'Outstanding Quantity'.shouldEqual('6')
      'Scan Status'.shouldEqual('Received 1 of Hoodie (H01)')
      'helper'.simulateScannerRead('RFT918273645')
      'Scan Status'.shouldEqual('Received 2 of Hoodie (H01)')
      'Received'.shouldEqual('2')
      'Outstanding Quantity'.shouldEqual('5')
      'Received Stocking Units'.shouldEqual('12')
      'OK'.click()
    'OK'.click()
  'Back'.click()

